import React, { Component } from 'react'
import '../Template/sb-admin-2.css';
import '../Template/sb-admin-2.min.css';

class Footer extends Component {
  render() {
    return (
      <footer className="sticky-footer bg-white">
        <div className="container my-auto">
          <div className="copyright text-center my-auto">
            <span>Copyright &copy; Your Website 2020</span>
          </div>
        </div>
      </footer>
    )
  }
}

export default Footer
